import React from "react";
import toast from "react-hot-toast";
import { useDispatch, useSelector } from "react-redux";
import { ListLayout } from "components/common/ListLayout";
import { inviteVendorsSelector, fetchInvitedVendors } from "slices/inviteVendorSlice";

const VendorsWithAppointments = ({ itemId, showInvitedList, height }) => {
    const dispatch = useDispatch()
    const { invitedVendors, loader } = useSelector(inviteVendorsSelector);
    // Note: The logic for "with appointments" might need a separate endpoint 
    // if it specifically means vendors who HAVE other appointments at the same time.
    // For now, I'll keep the structure similar to interpreters.
    
    const [selectedItems, setSelectedItems] = React.useState([]);

    const fetchData = async () => {
        // dispatch(fetchVendorsWithAppointments(itemId))
    };

    React.useEffect(() => {
        fetchData();
    }, [itemId]);


    const renderTableHeader = React.useCallback(() => {

        return (
            <tr>
                <th className="col-1">
                    <div className="row_check">
                        <span>#</span>
                    </div>
                </th>
                <th className="col-4">
                    <div className="" style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
                        <p>Name</p>
                    </div>
                </th>
                <th className="col-4">
                    <div className="" style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
                        <p>Email</p>
                    </div>
                </th>
                <th className="col-3">
                    <div className="" style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
                        <p>Languages</p>
                    </div>
                </th>

            </tr>
        )
    }, [])

    const renderTableContent = React.useCallback(() => {
        return null; // Implementation depends on whether "Vendors with Appointments" logic is needed
    }, []);

    return (
        <>
            <ListLayout
                heading=""
                title="Vendors with Appointment"
                addButtonDisabled={true}
                renderTableHeader={renderTableHeader}
                renderTableContent={renderTableContent}
                fetchList={fetchData}
                height={height}
                hidePageLength={true}
                hidePagination={true}
                hideSearchBar={true}
                loader={loader}
                showRemoveOnTop={true}
                containerStyle={{
                    marginTop: 20
                }}
                time={false}
            >
            </ListLayout>
        </>
    )

};

export default VendorsWithAppointments;
